import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import styled from "styled-components";

export const SegmentNamesContainer = styled.div`
    padding-top: 10px;
    display: flex;
    flex-direction: column;
    padding-right: 8px;
    border-right: solid 1px ${colorsPalettes.carbon[50]};
`;

export const SegmentLegendTitle = styled.p`
    ${setFontVariant("body2", colorsPalettes.carbon[500])}
    margin: 0px;
`;

export const SegmentLegendSubTitle = styled.p`
    ${setFontVariant("caption", colorsPalettes.carbon[400])}
    margin: 0px;
`;
